module.exports = __webpack_public_path__ + "static/media/questionCircle.48f2f7f8.svg";